export default "__VITE_ASSET__$wW_f0Z1__"